import * as React from "react";
import { connect } from "react-redux";
import * as Actions from "../../redux/actions";
import { AppState } from "../../redux";
import { OfferSection } from "./offer-section";
import { Entity } from "@radivision/graphql/lib/ts/graphql/entity";
import isEmpty from "lodash.isempty";

interface ComponentProps {
  entityId: string;
  owner: boolean;
}

interface MapDispatchProps {}
interface MapStateProps {
  entity: Entity & { marketplace: any };
}

export type Props = ComponentProps & MapDispatchProps & MapStateProps;

export const Component = (props: Props) => {
  const { entity, entityId, owner } = props;

  const offers = entity?.marketplace?.edges;
  const sections = [
    { title: "Pending Entries", status: "CREATED" },
    { title: "Active Entries", status: "ACCEPTED" },
    { title: "Rejected Entries", status: "REJECTED" },
    { title: "Expired Entries", status: "EXPIRED" },
  ];

  if (isEmpty(offers)) {
    return null;
    // if (owner) {
    //   return null;
    //   <h2 className="no-content">
    //     Your company&lsquo;s profile has no offers at the moment.
    //     <br />
    //     You can use &ldquo;Create Offer&rdquo; button to add more offers to your company profile.
    //   </h2>
    // }
    // return <h2 className="no-content">There are no marketplace offers at the moment. Please check back later.</h2>;
  }
  return (
    <div className="offer-sections">
      {sections.map((section) => {
        if (!owner) {
          if (section.status === "CREATED" || section.status === "REJECTED" || section.status === "EXPIRED")
            return null;
        }
        return <OfferSection key={section.title} section={section} entity={entity} />;
      })}
    </div>
  );
};

const mapState = (state: AppState, props: ComponentProps) => ({
  entity: props.entityId ? state.cache.store[props.entityId] : null,
});

const mapDispatch = {};

export const MarketplaceGrid = connect(mapState, mapDispatch)(Component);
